/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ending_Event_IdInputs */



/**
* | output |
* | --- |
* | "Ending Event Id" |
*
* @param {Ending_Event_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ending_event_id = /** @type {((inputs?: Ending_Event_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ending_Event_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID d’événement de fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endereignis-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID evento finale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор завершающего события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Id. del evento final")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结束事件 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了イベントID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति घटना आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID do evento de término")
	return /** @type {LocalizedString} */ ("Ending Event Id")
});